import { FormTagInputComponent } from 'src/features/generalForms/builder/types/TagInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useCallback } from 'react';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { RPDF } from 'src/features/report/react-pdf';

export const FormTagInput: FormTagInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback((arr: string[]) => arr.join(', ') ?? '', []);

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <RPDF.View />;
  }

  return <AnswerPreviewRow<string[]> value={value} renderValue={renderValue} {...props} />;
};
